const RelatedModel = require('./related_model')
const log = require('log').create('credit_card') // eslint-disable-line

const CreditCard = RelatedModel.extend({
    id: 'credit_card',

    defaults: {
        number: '',
        exp_month: '',
        exp_year: '',
        cvc: '',
        address_zip: '',
        last4: '',
    },

    calculated_values: {
        expiration() {
            const month = this.get('exp_month')
            const year = this.get('exp_year')
            if (month && year) {
                let pad = ''
                if (Number(month) < 10) pad = 0
                return `${pad}${month}/${year.slice(-2)}`
            }
            return ''
        },
        has_active() {
            if (this.get('last4') && this.get('expiration')) return true
            return false
        },
    },

    set() {
         
        let { attrs, options } = this.parseKeyValArguments.apply(this, arguments)

        attrs = this.coerceNumbersToStrings(attrs)

        return RelatedModel.prototype.set.apply(this, [attrs, options])
    },

    coerceNumbersToStrings(attrs) {
        // loop through values and coerce numbers to strings
        Object.keys(attrs).forEach(key => {
            // get the value
            let val = attrs[key]
            // convert numbers to strings
            if (typeof val === 'number') val = val.toString()
            // update the value
            attrs[key] = val
        })

        return attrs
    },

})

module.exports = CreditCard
